{
  "loading": "Caricamento...",
  "placeholder": "Seleziona…"
}
